import React, { useState } from "react";
import { Box } from "@mui/material";
import Select, { TOption, TOptionType } from "../../../Components/Select";
import { getDeviceOptions, getTimestampAttributeOptions } from "../utils";
import { IDevice } from "../../devices/types";
import { TTimestampCondition } from "./types";
import TimestampConditionPicker, {
  TTimestampUnit,
} from "../../../Components/TimestampConditionPicker";
import { useTranslation } from "react-i18next";

interface ITimestampConditionFormProps {
  condition: TTimestampCondition;
  devices: IDevice[];
  onChange: (timestampCondition: TTimestampCondition) => void;
}

const TimestampConditionForm = (props: ITimestampConditionFormProps) => {
  const { condition, devices, onChange } = props;
  const device_id = condition.device_id || devices[0].id;

  const [attributeOptions, setAttributeOptions] = useState<
    TOption<TOptionType>[]
  >(getTimestampAttributeOptions(devices, device_id));

  const [timestampCondition, setTimestampCondition] =
    useState<TTimestampCondition>({
      device_id: device_id,
      attribute: attributeOptions[0].value as string,
      ...condition,
    });
  const { t } = useTranslation();

  const updateTimestampCondition = (
    newTimestampCondition: TTimestampCondition
  ) => {
    setTimestampCondition(newTimestampCondition);
    onChange(newTimestampCondition);
  };

  return (
    <>
      <Select
        fullWidth
        label={t("Device")}
        options={getDeviceOptions(devices)}
        value={timestampCondition.device_id}
        onChange={(event) => {
          const newDeviceId = parseInt(event.target.value);
          const newAttributeOptions = getTimestampAttributeOptions(
            devices,
            newDeviceId
          );
          setAttributeOptions(newAttributeOptions);
          updateTimestampCondition({
            ...timestampCondition,
            device_id: newDeviceId,
            attribute: newAttributeOptions[0].value as string,
          });
        }}
        margin="none"
        data-cy="timestamp-condition-select-device"
      />
      <Box gap={1} display="flex" flexDirection="row">
        <Select
          label={t("Timestamp")}
          value={timestampCondition.attribute}
          options={attributeOptions}
          onChange={(event) => {
            updateTimestampCondition({
              ...timestampCondition,
              attribute: event.target.value,
            });
          }}
          margin="none"
          style={{ width: "70%" }}
          data-cy="timestamp-condition-select-attribute"
        />
        <TimestampConditionPicker
          label={t("Time Delta")}
          value={timestampCondition.value}
          unit={timestampCondition.unit}
          onConditionChange={(value: number, unit: TTimestampUnit) => {
            updateTimestampCondition({
              ...timestampCondition,
              value: value,
              unit: unit,
            });
          }}
          style={{ width: "30%" }}
          data-cy="timestamp-condition-condition-picker"
        />
      </Box>
    </>
  );
};

export default TimestampConditionForm;
